import { render, staticRenderFns } from "./ProveedoresCapacitacion.vue?vue&type=template&id=63f968a4"
import script from "./ProveedoresCapacitacion.vue?vue&type=script&lang=js"
export * from "./ProveedoresCapacitacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports